import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { submitContactUs } from "../api/api";
import LeftSidebar from "../components/sidebar";
import Header from "../components/Header";

export default function ContactUs() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.subject || !formData.message) {
      setError("");
      toast.error("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      setError("");
      await submitContactUs(formData);

      toast.success("Message sent successfully!");
      setFormData({ subject: "", message: "" });
    } catch (err) {
      console.error(err);
      setError("");
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="dashboard-screen">
      <div className="container-fluid">
        <div className="row gx-5">
          <div className="col-lg-3 left-sidebar-main">
           <LeftSidebar />
          </div>
          <div className="col-lg-9">
                    <Header />
            <div className="row contact-section" >
              <div className="col-sm-4">
                <div className="sec1">
                  <h1 className="get-in-touch">Get in Touch</h1>
                  <p className="subtext3">Connect with our team for support or inquiries</p>
                  <div className="mt-5 email-sec">
                    <div className="d-flex gap-2 mb-2">
                      <img src="icons/email2.svg" className="img-fluid"/>
                      <div>
                        <h4>Email Us :</h4>
                        <p><a href="mailto: support@pages.com"> support@pages.com</a></p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <img src="icons/phone2.svg" className="img-fluid"/>
                      <div>
                        <h4>Call Us :</h4>
                        <p><a href="tel: 1-800-123-9999"> 1-800-123-9999</a></p>
                      </div>
                    </div>
                  </div>
                  <div className="social">
                    <div className="social-links mb-2">
                      <a href="#"><img src="icons/facebook.svg" className="img-fluid"/></a>
                      <a href="#"><img src="icons/twitter.svg" className="img-fluid"/></a>
                      <a href="#"><img src="icons/instagram.svg" className="img-fluid"/></a>
                    </div>                  
                    <span>Follow us on social media</span>
                  </div>  
                </div>
              </div>
              <div className="col-sm-8">
                <div className="contact-form sec2">
                  <h3>Request a Callback</h3>
                  <p>Connect with our team at a time that suits you</p>
                  {error && <div className="alert alert-danger">{error}</div>}

                      <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <label className="form-label">Subject</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.subject}
                            onChange={(e) =>
                              setFormData({ ...formData, subject: e.target.value })
                            }
                            placeholder="Enter Subject"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Query</label>
                          <textarea
                            className="form-control form_textarea"
                            rows="4"
                            value={formData.message}
                            onChange={(e) =>
                              setFormData({ ...formData, message: e.target.value })
                            }
                            placeholder="Please enter your message here..."
                            required
                          />
                        </div>

                        <div className="">
                          <button
                            type="submit"
                            className="btn3"
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Submit Message"}
                          </button>
                        </div>
                      </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>
  );
}
